import { isNil } from "lodash";
import { Row } from "PFApp/booking/types";
import React from "react";

import { WorkforceCalendarData } from "../../../context/booking_overview_context.types";
import { useBookingsOverviewContext } from "../../../context/bookings_overview_context";
import { useCalendarContext } from "../../../context/calendar_context";
import { useUtilizationDataProvider } from "../../../workforce_metrics";
import HeatMapItem from "./heat_map_item";
import { useHeatMapItems } from "./use_heat_map_items";

interface HeatMapRowProps {
  row: Row;
  startDate: string;
}

export const HeatMapRow = ({ row, startDate }: HeatMapRowProps): JSX.Element => {
  const { dayWidth } = useCalendarContext();
  const items = useHeatMapItems({ row, startDate, dayWidth });
  const {
    calendarData: { thresholds }
  } = useBookingsOverviewContext<WorkforceCalendarData>();
  const { getUtilizationValue, getUtilizationLabel, getBackgroundColor } = useUtilizationDataProvider();

  return (
    <>
      {items.map((item) => {
        const value = getUtilizationValue(item);
        const label = getUtilizationLabel(value);
        return (
          <HeatMapItem
            key={`${row.key}_${item.date}`}
            label={label ?? ""}
            bgColor={!isNil(value) ? getBackgroundColor(value, thresholds.heatmap) : undefined}
            shouldDisplayLabel={
              !isNil(value) && ((value < 10 && item.width > 30) || (value >= 10 && item.width > 40))
            }
            {...item}
          />
        );
      })}
    </>
  );
};
